/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const jiraInstanceSchema = z.object({
  id: z.string(),
  name: z.string(),
  url: z.string(),
});
